import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPostCustomerAccountRequestSchema,
  TPostCustomerAccountResponseSchema,
} from "@zeal/common";

export const createCustomerAccount = (axios: IAxiosInstance) => {
  return async (
    data: Omit<
      TPostCustomerAccountRequestSchema,
      "company_id" | "partner_id"
    > & { companyID: string }
  ) => {
    const response = await axios.noRetry.post<
      IApiResponse<TPostCustomerAccountResponseSchema>
    >(`/customer-accounts`, data);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
